import { createFileRoute } from "@tanstack/react-router";
import { Landing } from "@/components/landing/Landing";
import { heroLcpPreloadHref, heroPicture } from "@/lib/images";

const OG_IMAGE =
  "https://storage.googleapis.com/gpt-engineer-file-uploads/H11f8sPnVxbVMPidooAs9ItoKYe2/social-images/social-1782927938663-Gemini_Generated_Image_rhco8erhco8erhco.webp";
const TITLE = "Carolina Mountain Stamps | US & World Collectibles";
const DESCRIPTION =
  "Shop Carolina Mountain Stamps for collectible US & world postage stamps, souvenir sheets, first day covers, and plate blocks from Hendersonville, NC.";

export const Route = createFileRoute("/")({
  component: Landing,
  head: () => ({
    meta: [
      { title: TITLE },
      { name: "description", content: DESCRIPTION },
      { property: "og:title", content: TITLE },
      { property: "og:description", content: DESCRIPTION },
      { property: "og:url", content: "https://carolinamountainstamps.com/" },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary_large_image" },
      { property: "og:image", content: OG_IMAGE },
      { name: "twitter:title", content: TITLE },
      { name: "twitter:description", content: DESCRIPTION },
      { name: "twitter:image", content: OG_IMAGE },
    ],
    links: [
      { rel: "canonical", href: "https://carolinamountainstamps.com/" },
      {
        rel: "preload",
        as: "image",
        type: "image/avif",
        href: heroLcpPreloadHref,
        imageSrcSet: heroPicture.avifSrcSet,
        imageSizes: heroPicture.sizes,
        fetchPriority: "high",
      },
    ],
  }),
});
